import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import uz from '@/locales/uz/translation.json'
import ru from '@/locales/ru/translation.json'
import en from '@/locales/en/translation.json'

export const SUPPORTED_LOCALES = ['uz', 'ru', 'en']
export const STORAGE_KEY       = '5mi_admin_locale'
export const DEFAULT_LOCALE    = import.meta.env.VITE_DEFAULT_LOCALE ?? 'uz'

function detectLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored
  const browser = (navigator.language ?? '').split('-')[0]
  return SUPPORTED_LOCALES.includes(browser) ? browser : DEFAULT_LOCALE
}

i18n.use(initReactI18next).init({
  resources: {
    uz: { translation: uz },
    ru: { translation: ru },
    en: { translation: en },
  },
  lng:           detectLanguage(),
  fallbackLng:   'uz',
  supportedLngs: SUPPORTED_LOCALES,
  defaultNS:     'translation',
  ns:            ['translation'],
  interpolation: { escapeValue: false },
  react:         { useSuspense: false },
})

export function setLocale(lng) {
  if (!SUPPORTED_LOCALES.includes(lng)) return
  localStorage.setItem(STORAGE_KEY, lng)
  i18n.changeLanguage(lng)
}

export default i18n

